/**
 * @generated SignedSource<<d201c0e493fbc85190c89b8fcd4d4e2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type UpscalerInput = {
  enableCreativity: boolean;
  imageUrl: string;
  saveToLibrary: boolean;
  scaleFactor: number;
};
export type tasksStartUpscalerMutation$variables = {
  input: UpscalerInput;
};
export type tasksStartUpscalerMutation$data = {
  readonly startUpscaler: {
    readonly createdAt: string;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type tasksStartUpscalerMutation = {
  response: tasksStartUpscalerMutation$data;
  variables: tasksStartUpscalerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpscalerTask",
    "kind": "LinkedField",
    "name": "startUpscaler",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksStartUpscalerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tasksStartUpscalerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7602983d19b307f60141ba1a55dceac4",
    "id": null,
    "metadata": {},
    "name": "tasksStartUpscalerMutation",
    "operationKind": "mutation",
    "text": "mutation tasksStartUpscalerMutation(\n  $input: UpscalerInput!\n) {\n  startUpscaler(input: $input) {\n    taskId\n    state\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "1128b0283b951a841e950ae3a095e9f4";

export default node;
